import { j as G } from "./jsx-runtime-3tyXYecC.mjs";
import { _ as K } from "./composeRefs-YONvD-rx.mjs";
import { l as Y } from "./lodash-5ofSKtz3.mjs";
import { useRef as j, useImperativeHandle as J } from "react";
import { d as a } from "./index-B0UJGM1i.mjs";
import { parseISO as L, formatISO as N } from "date-fns";
import { e as C } from "./add-rhf-default-error-message-C9MkLfg3.mjs";
import { e as i } from "./extract-rhf-validation-rule-value-DyB3XAHu.mjs";
import { a as U } from "./add-rhf-default-error-messages-DzyaQrlA.mjs";
import { D as X } from "./date-picker-FVIC1w4I.mjs";
import { g as Z } from "./get-aria-describedby-G1wcWKF2.mjs";
import { u as P } from "./use-rhf-wrapper-controller-DGFm3TD5.mjs";
import { t as ee } from "./toggle-rhf-rules-Z1TdwfO9.mjs";
import { c as y } from "./combine-function-calls-C5qD-ZYI.mjs";
function s(e) {
  if (a.isValid(L(e)))
    return a.parseISO(e);
}
const v = {
  afterMax: window.jQuery ? $.__("Please select a date before the maximum date.") : "Please select a date before the maximum date.",
  beforeMin: window.jQuery ? $.__("Please select a date after the minimum date.") : "Please select a date after the minimum date.",
  disabled: window.jQuery ? $.__("This date isn't available. Please choose another date.") : "This date isn't available. Please choose another date.",
  invalid: window.jQuery ? $.__("We can't recognize this date.") : "We can't recognize this date.",
  required: window.jQuery ? $.__("Please add a date.") : "Please add a date."
};
function te(e) {
  return (r) => {
    const t = s(r);
    if (!(!t || typeof e != "function"))
      return e({
        date: N(t, { representation: "date" }),
        day: a.getDate(t),
        month: a.getMonth(t),
        year: a.getYear(t)
      }) ? v.disabled : void 0;
  };
}
function ae(e) {
  return (r) => {
    const t = i(e), o = t ? s(t) : void 0, n = s(r);
    if (o && n && a.isAfter(a.startOfDay(n), a.startOfDay(o)))
      return C(e, v.afterMax);
  };
}
function re(e) {
  return (r) => {
    const t = i(e), o = t ? s(t) : void 0, n = s(r);
    if (o && n && a.isBefore(a.startOfDay(n), a.startOfDay(o)))
      return C(e, v.beforeMin);
  };
}
function ve({
  apiRef: e,
  ariaDescribedby: r,
  containerRef: t,
  control: o,
  defaultValue: n = "",
  disabled: b,
  errorMessageId: x,
  getDateDisabled: R,
  inputProps: d,
  onBlur: E,
  onCalendarDateSelect: F,
  onChange: _,
  onInputChange: M,
  maxDate: u,
  minDate: l,
  name: H,
  required: f,
  shouldUnregister: A,
  status: Q,
  validate: D,
  ...V
}) {
  var I;
  const B = u ? i(u) : void 0, k = l ? i(l) : void 0, T = {
    maxDate: ae(u),
    minDate: re(l),
    getDateDisabled: te(R),
    ...typeof D == "function" ? { custom: D } : D
  }, { field: O, fieldState: g } = P({
    control: o,
    defaultValue: n,
    name: H,
    // This is a workaround for `disabled` because it is not available in `useController` yet (not available until v7.48.0).
    rules: ee(
      {
        ...U({ required: f }),
        validate: T
      },
      b
    ),
    shouldUnregister: A
  }), { onBlur: W, onChange: z, value: S } = O, p = j(S), w = (m) => {
    const { value: c = "" } = m;
    z(c), typeof _ == "function" && p.current !== c && (p.current = c, _(c));
  }, h = j();
  J(e, () => ({ focus: () => {
    var m;
    return (m = h.current) == null ? void 0 : m.focus();
  } }), [h]);
  const q = typeof f == "string" ? !!f : i(f);
  return /* @__PURE__ */ G.jsx(
    X,
    {
      ...V,
      ariaDescribedby: Z(g.error ? x : void 0, r),
      disabled: b,
      errorMessage: x || (I = g.error) == null ? void 0 : I.message,
      getDateDisabled: R,
      inputProps: {
        ...d,
        ref: K(h, O.ref, d == null ? void 0 : d.ref)
      },
      maxDate: B,
      minDate: k,
      onBlur: y(W, E),
      onCalendarDateSelect: y(F, w),
      onChange: Y.noop,
      onInputChange: y(M, w),
      ref: t,
      required: q,
      status: g.error ? "error" : Q,
      value: S
    }
  );
}
export {
  ve as D
};
//# sourceMappingURL=date-picker-rhf-BhjB5yrX.mjs.map
